// extracted by mini-css-extract-plugin
export var errorIcon = "_i9-1";
export var nameLogo = "_i9-0";